import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Overview from '../views/Overview.vue'
import { auth } from '@/firebase'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Overview',
    component: Overview,
    meta: {
      title: 'Kontaktlinsen App',
      gtm: 'App-Overview'
    }
  },
  {
    path: '/notifications/:contactlensId?',
    name: 'Notifications',
    component: () => import(/* webpackChunkName: "notifications" */ '../views/Notifications.vue'),
    meta: {
      title: 'Benachrichtigungen',
      gtm: 'App-Notifications'
    }
  },
  {
    path: '/notificationThankYou/:contactlensIdLeft/:contactlensIdRight',
    name: 'NotificationThankYou',
    component: () => import(/* webpackChunkName: "notificationsThankYou" */ '../views/NotificationThankYou.vue'),
    meta: {
      requiresAuth: true,
      title: 'Benachrichtigungen',
      gtm: 'App-Notifications Thank You'
    }
  },
  {
    path: '/ratings/:type?/:refId?/:refName?',
    name: 'Ratings',
    component: () => import(/* webpackChunkName: "ratings" */ '../views/Ratings.vue'),
    meta: {
      requiresAuth: true,
      title: 'Bewertungen',
      gtm: 'App-Ratings'
    }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import(/* webpackChunkName: "profile" */ '../views/Profile.vue'),
    meta: {
      requiresAuth: true,
      title: 'Profil',
      gtm: 'App-Profile'
    }
  },
  {
    path: '/unsubscribed',
    name: 'Unsubscribed',
    component: () => import(/* webpackChunkName: "unsubscribed" */ '../views/Unsubscribed.vue'),
    meta: {
      title: 'Abgemeldet!',
      gtm: 'App-Unsubscribed'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
    meta: {
      title: 'Anmelden...',
      gtm: 'App-Login',
      transitionName: 'zoom'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title // update title
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  if (requiresAuth && !auth.currentUser) {
    router.push({ name: 'Login', query: { to: to.path, from: from.path } })
  } else {
    next()
  }
})

export default router
